import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LegalAgreementsContact from "@/components/legal/LegalAgreementsContact";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const [, setActiveSection] = useState(null);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
    }
  };

  const tableOfContents = Array.from({ length: 18 }, (_, i) => ({
    id: `section-${i + 1}`,
    title: t(`privacyPolicy_toc${i + 1}`),
  }));

  const renderSectionBody = (n: number, body: string) => {
    if (n === 1 && body.includes("www.jandipr.com")) {
      return (
        <p className="text-gray-700 leading-relaxed">
          {body.split("www.jandipr.com").map((part, i, arr) =>
            i < arr.length - 1 ? (
              <React.Fragment key={i}>
                {part}
                <a
                  href="https://www.jandipr.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-darkBlue underline"
                >
                  www.jandipr.com
                </a>
              </React.Fragment>
            ) : (
              part
            )
          )}
        </p>
      );
    }
    return body.split(/\n\n/).map((para, i) => (
      <p key={i} className="text-gray-700 leading-relaxed">
        {para}
      </p>
    ));
  };

  return (
    <div className="min-h-screen bg-home">
      <header className="bg-darkBlue text-white">
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-12 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              {t("privacyPolicy_pageTitle")}
            </h1>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8 p-4 bg-lightBlue border-l-4 border-darkBlue rounded-r-lg">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">{t("privacyPolicy_lastUpdatedLabel")}</span>{" "}
            {t("privacyPolicy_lastUpdatedText")}
          </p>
        </div>

        <div className="mb-12 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-lightBlue border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              {t("privacyPolicy_tocTitle")}
            </h2>
          </div>
          <div className="px-6 py-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {tableOfContents.map((item, index) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left p-2 text-darkBlue hover:text-darkBlue hover:bg-lightBlue rounded transition-colors duration-200"
                >
                  <span className="">{index + 1}.</span> {item.title}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="space-y-12">
          {Array.from({ length: 18 }, (_, i) => i + 1).map((n) => (
            <section key={n} id={`section-${n}`} className="scroll-mt-8">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 bg-lightBlue border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                    <span className="bg-darkBlue text-white px-3 py-1 rounded-full text-sm font-bold">
                      {n}
                    </span>
                    {t(`privacyPolicy_s${n}Title`)}
                  </h2>
                </div>
                <div className="px-6 py-6 space-y-4">
                  {renderSectionBody(n, t(`privacyPolicy_s${n}Body`))}
                </div>
              </div>
            </section>
          ))}

          <LegalAgreementsContact />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
